<div class="biz-page">

    <a routerLink="/biz-directory" class="small d-inline-block mb-3">&larr; Business Directory</a>

    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title">Starting a business?</h1>
            <p class="rana-page-subtitle mb-0">You do not have to figure it out alone. Learn from members who have done it, and get found by people who can help.</p>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-lg-6 mb-4">
            <div class="rana-panel h-100">
                <div class="rana-panel-title">1. See who is already doing it</div>
                <p>Search the directory by category, city or state and see how other members describe and run similar businesses.</p>
                <a class="btn btn-dark-primary" routerLink="/biz-directory">Browse the directory</a>
            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="rana-panel h-100">
                <div class="rana-panel-title">2. List your own business</div>
                <p>A free listing with your logo, offerings and what you are looking for: customers, partners, investors or mentors.</p>
                <a class="btn btn-dark-primary" *ngIf="isMember" routerLink="/biz-directory/new">Add your business</a>
                <a class="btn btn-dark-primary" *ngIf="!loggedIn" routerLink="/login">Log in to list your business</a>
                <span class="size-13 text-muted" *ngIf="loggedIn && !isMember">Listing a business is for RANA members.</span>
            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="rana-panel h-100">
                <div class="rana-panel-title">3. Find people to work with</div>
                <p>Post what you need on the opportunities board: a co-founder, a first hire, a supplier or an investor.</p>
                <a class="btn btn-dark-primary" routerLink="/biz-opportunities">Open the board</a>
            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="rana-panel h-100">
                <div class="rana-panel-title">First steps checklist</div>
                <ul class="start-checklist mb-0">
                    <li *ngFor="let step of checklist">{{ step }}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="mb-3" *ngIf="mentors.length">
        <h5 class="mb-1">Members happy to mentor</h5>
        <p class="text-muted size-14">Each of these owners has offered to talk with members starting something similar. Open a listing and choose "Ask for mentoring".</p>
        <div class="row">
            <div class="col-md-4 mb-3" *ngFor="let m of mentors">
                <app-biz-card [biz]="m" [chapterName]="chapterName(m)"></app-biz-card>
            </div>
        </div>
        <a routerLink="/biz-directory" [queryParams]="{mentor: 1}">See every mentor &rarr;</a>
    </div>
</div>
